import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QrAttendanceComponent } from './qr-attendance.component';

const routes: Routes = [
  {
    path: '',
    component: QrAttendanceComponent, 
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QrAttendanceRoutingModule { }